<template>
<li v-if="showInstallLink && deferredPrompt" @click="installPwa">
  <a onclick="event.preventDefault();return false;" style="cursor:pointer">{{ $t("message['Installer l application']") }}</a>
</li>
</template>

<script>
import storeJs from 'store'

export default {
  name: 'InstallPwa',
  components: {},

  data() {
    return {
      showInstallLink: false,
      deferredPrompt: null
    }
  },

  created() {
    if (this.available()) {
      console.debug('InstallPWA', 'PWA available')
      this.listenInstallPrompt()
      this.registerServiceWorker()
    } else {
      console.debug('InstallPWA', 'PWA not available')
      this.showInstallLink = false
    }
  },

  mounted() {
    // Cas PWA : cartographie
    if (this.getParameterByName('utm_source') === 'web_app_manifest') {
      this.$router.push('/cartographie')
    }
  },

  methods: {
    available() {
      // TODO tester Chrome ? Ou Chrome sous Android ?
      return window.location.protocol === 'https:' && 'serviceWorker' in navigator
    },

    listenInstallPrompt() {
      console.debug('InstallPWA', 'Ecoute beforeinstallprompt')
      window.addEventListener('appinstalled', (evt) => {
        console.debug('InstallPWA', 'Application installée')
        this.showInstallLink = false
      })
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault()
        this.deferredPrompt = e
        this.showInstallLink = true
        if (storeJs.get('cr:hide-homescreen') === true) {
          console.debug('InstallPWA', 'Demande d\'installation immédiate ignorée (choix utilisateur)')
        } else {
          console.debug('InstallPWA', 'Demande d\'installation immédiate')
          this.installPwa()
        }
      })
    },

    registerServiceWorker() {
      navigator.serviceWorker.register('/sw-pwa.js').then(registration => {
        console.debug('InstallPWA', 'Enregistrement du ServiceWorker avec le scope', registration.scope)
      }, err => {
        console.debug('InstallPWA', 'Echec enregistrement du ServiceWorker', err)
        this.showInstallLink = false
      })
    },

    installPwa() {
      if (!this.deferredPrompt) {
        console.debug('InstallPWA', 'Prompt absent : impossible d\'installer')
        this.showInstallLink = false
        return
      }
      this.deferredPrompt.prompt()
      this.deferredPrompt.userChoice
        .then((choice) => {
          if (choice.outcome === 'accepted') {
            console.debug('InstallPWA', 'Demande d\'installation acceptée')
            this.showInstallLink = false
            // TODO notify "Merci" ?
          } else {
            console.debug('InstallPWA', 'Demande d\'installation refusée')
            storeJs.set('cr:hide-homescreen', true)
          }
        })
      this.deferredPrompt = null
    },

    getParameterByName(name, url) {
      if (!url) url = window.location.href
      name = name.replace(/[[]]/g, '\\$&')
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
      const results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    }
  }
}
</script>

<style scoped>

</style>
